// import {tracs_api} from "../../services/api.interceptor/tracs_api";
import { tracs_api } from "../../services/api.interceptor";
class CommonService{
    getnlcs(tocs?:number[]|null){
        let toc=null;
        let tocfromStorage=localStorage.getItem('Toc');
        if(tocfromStorage){
            toc=JSON.parse(tocfromStorage);
        }
        return tracs_api
        .post(process.env.REACT_APP_DATAMANAGEMENT_API+ "Lookup/GetNLCs",(!tocs&&toc?[toc?.Id]:tocs??[]));
    }


    getTicketTypes(){
        return tracs_api
        .post(process.env.REACT_APP_DATAMANAGEMENT_API+ "Lookup/GetTicketTypes");
    }

    getTocs(){
        return tracs_api
        .post(process.env.REACT_APP_DATAMANAGEMENT_API+ "Lookup/GetTocs");
    }

}

export default new CommonService();